import { v4 as uuidv4 } from "uuid";

export function getUserId() {
  let id = localStorage.getItem("weddingUserId");
  if (!id) {
    id = uuidv4();
    localStorage.setItem("weddingUserId", id);
  }
  return id;
}

export function getUserName() {
  return localStorage.getItem("weddingUserName") || "";
}

export function setUserName(name) {
  localStorage.setItem("weddingUserName", name);
}
